import React, { useState } from "react"

import Select from "react-select"

import { AlertMessageBox } from "~tailwindui/Basics"

import { PLAYBACK_RATE_OPTIONS } from "src/playbackRateOptions"

import { gql, useMutation } from "hooks/urql"

type Props = {
  studentSessionId: string
  audioPlaybackRate: number
  disabled: boolean
}

const SetAudioPlaybackRate: React.FC<Props> = ({
  studentSessionId,
  audioPlaybackRate,
  disabled,
}) => {
  const [error, setError] = useState<string | null>(null)
  const [, runMutation]: any[] = useMutation(updateRateMutation)

  const handleSubmit = newRate => {
    setError(null)

    runMutation({
      studentSessionId,
      audioPlaybackRate: newRate,
    })
      .then(result => {
        const { failures } = result.data.studentSessionUpdateAudioPlaybackRate
        if (failures.length > 0) {
          setError(failures[0].message)
        } else {
          window.location.reload()
        }
      })
      .catch(() => setError("Something went wrong"))
  }

  return (
    <>
      <div className="form-group min-w-[200px]">
        <label className="form-label w-100">
          <span>Audio Playback Speed:</span>
          <div>
            <Select
              options={PLAYBACK_RATE_OPTIONS}
              defaultValue={PLAYBACK_RATE_OPTIONS.find(
                opt => opt.value === audioPlaybackRate
              )}
              onChange={opt => handleSubmit(opt?.value)}
              menuPortalTarget={document.body}
              isDisabled={disabled}
              styles={{
                container: provided => ({
                  ...provided,
                  maxWidth: 250,
                }),
              }}
            />
          </div>
        </label>
      </div>
      {error && <AlertMessageBox>{error}</AlertMessageBox>}
    </>
  )
}

const updateRateMutation = gql`
  mutation studentSessionUpdateAudioPlaybackRate(
    $studentSessionId: ID!
    $audioPlaybackRate: Float!
  ) {
    studentSessionUpdateAudioPlaybackRate(
      studentSessionId: $studentSessionId
      audioPlaybackRate: $audioPlaybackRate
    ) {
      studentSession {
        id
        audioPlaybackRate
      }
      failures {
        message
      }
    }
  }
`

export default SetAudioPlaybackRate
